export const CREATE_EXPERIENCE = 'CREATE_EXPERIENCE'
export const UPDATE_EXPERIENCE = 'UPDATE_EXPERIENCE'
export const DELETE_EXPERIENCE = 'DELETE_EXPERIENCE'
